<template>
  <!-- eslint-disable vue/no-v-html -->
  <page-wrapper-article :article="article">
    <div class="wrapper">
      <div class="decor decor__1" />
      <ol class="breadcrumbs" itemscope="" itemtype="http://schema.org/BreadcrumbList">
        <li
          id="breadcrumbs__item_0"
          class="breadcrumbs__item"
          itemscope=""
          itemprop="itemListElement"
          itemtype="http://schema.org/ListItem"
        >
          <a itemprop="item" href="/" target="_self">
            <span itemprop="name">Салон Love Forever</span>
          </a>
          <meta content="1" itemprop="position">
        </li>
        <li itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">
          <span itemprop="name">Статьи</span>
          <meta content="2" itemprop="position">
        </li>
      </ol>
      <section class="wrapper_text">
        <div class="article-detail">
          <h1 class="wrapper_title">
            <span class="wrapper_title_decor">{{ article.title }}</span>
          </h1>

          <div v-if="article.images.length > 0">
            <hr>
            <img
              :src="`${IMAGE_URL}/uploads/articles/${article.images[0].hash}${article.images[0].ext}`"
              :alt="article.title"
              :title="article.title"
              class="detail_picture"
              border="0"
              width="450"
            >
            <hr>
          </div>

          <ArticleWrapper :article="article.content" />

          <hr class="small-padding">
        </div>
        <p>
          <a href="/articles/" target="_self">
            Возврат к списку
          </a>
        </p>
      </section>
    </div>
  </page-wrapper-article>
</template>

<script>
import { CLIENT_URL, IMAGE_URL } from '@/assets/js/constants'
import ArticleWrapper from '@/components/ArticleWrapper'
import PageWrapperArticle from './PageWrapperArticle'
export default {
  name: 'ArticlePage',
  components: { PageWrapperArticle, ArticleWrapper },
  async asyncData ({ params, $axios, store, error, query }) {
    const articleSlug = params.article || null
    if (!articleSlug) {
      return error({
        statusCode: 404,
        message: 'Тут только лепестки роз'
      })
    }

    let article
    if (!store.state.articles.length) {
      const loadedArticles = await $axios.get(`/articles?slug=${articleSlug}`)
      if (!loadedArticles.data.length) {
        return error({
          statusCode: 404,
          message: 'Тут только лепестки роз'
        })
      }

      article = loadedArticles.data[0]
    } else {
      article = store.state.articles.find(item => item.slug === articleSlug)
    }

    const seoResult = store.state.seoEntities.find(item => item.type === 'article')
    return {
      seo: seoResult ? seoResult.seo[0] : null,
      article
    }
  },
  data: () => {
    return {
      IMAGE_URL
    }
  },
  computed: {
    fullFilledSeoTitle () {
      return this.fillSeoTemplate(this.seoTitle)
    },
    fullFilledSeoDescription () {
      return this.fillSeoTemplate(this.seoDescription)
    },
    seoTitle () {
      if (this.article.seo) {
        return this.article.seo.title
      } else if (this.seo) {
        return this.seo.title
      }

      return this.article.title
    },
    seoKeywords () {
      if (this.article.seo) {
        return this.article.seo.keywords
      } else if (this.seo) {
        return this.seo.keywords
      }

      return null
    },
    seoDescription () {
      if (this.article.seo) {
        return this.article.seo.description
      } else if (this.seo) {
        return this.seo.description
      }

      return null
    },
    canonicalUrl () {
      return `${CLIENT_URL}/articles/${this.article.slug}/`
    },
    articleMetatags () {
      const result = []
      if (this.fullFilledSeoDescription) {
        result.push({ hid: 'description', name: 'description', content: this.fullFilledSeoDescription })
      }
      if (this.seoKeywords) {
        result.push({ hid: 'keywords', name: 'keywords', content: this.seoKeywords })
      }
      if (this.article.images.length > 0) {
        result.push({ hid: 'og:image', property: 'og:image', content: `${IMAGE_URL}/uploads/${this.article.images[0].hash}${this.article.images[0].ext}` })
      }
      result.push({ hid: 'og:site_name', property: 'og:site_name', content: 'Салон свадебной и вечерней моды Love Forever' })
      result.push({ hid: 'og:locale', property: 'og:locale', content: 'ru_RU' })
      result.push({ hid: 'og:type', property: 'og:type', content: 'article' })
      return result
    }
  },
  mounted () {
    if (this.$fb) {
      this.$fb.track('ViewContent', {
        content_name: this.article.title,
        content_category: 'article'
      })
    }
  },
  methods: {
    fillSeoTemplate (str) {
      if (!str) {
        return ''
      }

      str = str.replace(/{article_title}/g, this.article.title)
      str = str.replace(/{article_intro}/g, this.article.intro)

      return str
    }
  },
  head () {
    return {
      bodyAttrs: {
        class: 'page-loveforever is-loaded'
      },
      title: this.fullFilledSeoTitle,
      meta: this.articleMetatags,
      link: [{ rel: 'canonical', href: this.canonicalUrl }]
    }
  }
}
</script>

<style>
.article-detail .detail-text {
  text-align: left;
}
.article-detail hr.small-padding {
  margin-bottom: 30px;
}
.article-detail .share-panel {
  margin-bottom: 30px;
}
blockquote {
  margin: 0 0 20px 0;
  background: #F0F0F1;
  color: #333334;
  padding: 20px 30px;
  position: relative;
  border-left: 35px solid #DFDEDE;
  font-family: 'Lato', sans-serif;
}
blockquote:before {
  content: "\201C";
  font-family: serif;
  position: absolute;
  left: -29px;
  top: 5px;
  color: #BCBCBC;
  font-size: 50px;
  text-shadow: 1px 2px 0 white;
}
blockquote p {
  margin: 0 0 16px;
  font-size: 16px;
  letter-spacing: .05em;
  line-height: 1.4;
}
blockquote cite {
  font-style: normal;
  font-weight: 300;
}
h2 {
  font-size: 28px !important;
  letter-spacing: 2px !important;
}
.ul-text {
  list-style-type: disc;
}
.ol-text {
  list-style-type: decimal;
}
</style>
